import Vue from "vue";
import App from "./App.vue";
import Vuetify from "vuetify/lib";
import Vuelidate from "vuelidate";
import Vuex from "vuex";
import VueRouter from "vue-router";
import "./styles/buttons.css";
import "./styles/texts.css";
import "./styles/logos.css";
import VueI18n from "vue-i18n";
import PaymentReturn from "./components/PaymentReturn";
import registrationModule from "./store";
import Registration from "./components/Registration.vue";
import de_ai from "./i18n/de_ai.json";
import de_as from "./i18n/de_as.json";
import de_certible from "./i18n/de_certible.json";
import en_ai from "./i18n/en_ai.json";
import en_as from "./i18n/en_as.json";
import en_certible from "./i18n/en_certible.json";
import en_cmp from "./i18n/en_cmp.json";

Vue.config.productionTip = false;
Vue.use(Vuelidate);
Vue.use(Vuex);
Vue.use(VueI18n);
Vue.use(VueRouter);
Vue.use(Vuetify);

function loadLocaleMessages() {
  const messages = {};
  messages["de_certible"] = de_certible;
  messages["de_ai"] = {
    ...de_certible,
    ...de_ai,
  };
  messages["de_as"] = {
    ...de_certible,
    ...de_as,
  };
  messages["en_certible"] = en_certible;
  messages["en_ai"] = {
    ...en_certible,
    ...en_ai,
  };
  messages["en_as"] = {
    ...en_certible,
    ...en_as,
  };
  messages["en_cmp"] = {
    ...en_certible,
    ...en_cmp,
  };
  return messages;
}

export const store = new Vuex.Store({
  modules: {
    registration: registrationModule,
  },
});

if (typeof window !== "undefined") {
  let urlParams = new URLSearchParams(window.location.search);
  if (process.env.VUE_APP_TENANT === "cmp") {
    store.dispatch("registration/updateLocale", "en");
  } else if (urlParams.has("locale")) {
    let locale = urlParams.get("locale");
    if (locale === "en" || locale === "de") {
      store.dispatch("registration/updateLocale", locale);
    } else {
      store.dispatch("registration/updateLocale", window.g_language || "de");
    }
  } else if (process.env.VUE_APP_TENANT === "certible") {
    if (window.location.pathname.startsWith("/de/")) {
      store.dispatch("registration/updateLocale", "de");
    } else {
      store.dispatch("registration/updateLocale", "en");
    }
  } else {
    store.dispatch("registration/updateLocale", window.g_language || "de");
  }
}

const i18n = new VueI18n({
  locale: store.getters["registration/locale"] + "_" + store.getters["registration/tenant"],
  messages: loadLocaleMessages(),
});

if (typeof window !== "undefined") {
  window.i18n = i18n;
}

const vuetify = new Vuetify({
  icons: {
    defaultAssets: false,
    values: {
      closeCircle:
        "M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z",
      checkboxMarkedCircle:
        "M10,17L5,12L6.41,10.58L10,14.17L17.59,6.58L19,8M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z",
      close:
        "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z",
      information:
        "M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z",
      menuDown: "M7,10L12,15L17,10H7Z",
      checkboxOff:
        "M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M19,5V19H5V5H19Z",
      checkboxOn:
        "M10,17L5,12L6.41,10.58L10,14.17L17.59,6.58L19,8M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3Z",
      checkboxIndeterminate:
        "M19,19H5V5H15V3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V11H19M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z",
      dropdown: "M7,10L12,15L17,10H7Z",
      prev: "M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z",
      next: "M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z",
      radioOn:
        "M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,7A5,5 0 0,0 7,12A5,5 0 0,0 12,17A5,5 0 0,0 17,12A5,5 0 0,0 12,7Z",
      radioOff:
        "M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z",
      earth:
        "M17.9,17.39C17.64,16.59 16.89,16 16,16H15V13A1,1 0 0,0 14,12H8V10H10A1,1 0 0,0 11,9V7H13A2,2 0 0,0 15,5V4.59C17.93,5.77 20,8.64 20,12C20,14.08 19.2,15.97 17.9,17.39M11,19.93C7.05,19.44 4,16.08 4,12C4,11.38 4.08,10.78 4.21,10.21L9,15V16A2,2 0 0,0 11,18M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z",
      paperclip:
        "M16.5,6V17.5C16.5,19.71 14.71,21.5 12.5,21.5C10.29,21.5 8.5,19.71 8.5,17.5V5C8.5,3.62 9.62,2.5 11,2.5C12.38,2.5 13.5,3.62 13.5,5V15.5C13.5,16.05 13.05,16.5 12.5,16.5C11.95,16.5 11.5,16.05 11.5,15.5V6H10V15.5C10,16.88 11.12,18 12.5,18C13.88,18 15,16.88 15,15.5V5C15,2.79 13.21,1 11,1C8.79,1 7,2.79 7,5V17.5C7,20.54 9.46,23 12.5,23C15.54,23 18,20.54 18,17.5V6H16.5Z",
    },
  },
});

const routes = [
  { path: "/", component: Registration },
  { path: "/payment-landing/:provider", name: "payment", component: PaymentReturn },
];

const router = new VueRouter({
  routes,
});

new Vue({
  i18n,
  vuetify,
  store: store,
  router,
  render: (h) => h(App),
}).$mount("#app");

export { i18n, vuetify };
